<template>
  <div class="graph_box mt-2">
    <div class="flex">
      <div>
        <p class="heading" style="transform: translateY(-8px)">{{ heading }}</p>
      </div>
      <v-spacer />
      <div v-if="items.length > 0" class="mr-2">
        <v-menu offset-y :close-on-content-click="showFilter">
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
              class="flex"
              @click="
                showFilter = false;
                closebuttonText == 'Close' ? (selected = []) : '';
              "
            >
              <p>{{ filterText }}</p>
              <v-icon style="transform: translateY(-8px)">mdi-menu-down</v-icon>
            </div>
          </template>
          <div style="width: 300px">
            <div
              style="
                height: 200px;
                background-color: #fff;
                overflow-y: scroll;
                margin-bottom: 1rem;
              "
            >
              <v-list>
                <v-list-item
                  v-for="(item, index) in items"
                  :key="index"
                  @click="userFilter = item"
                >
                  <v-list-item-title>
                    <v-checkbox
                      v-model="selected"
                      :label="item"
                      :value="item"
                      style="
                        height: 30px !important;
                        transform: translateY(-10px);
                      "
                    ></v-checkbox>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </div>
            <div class="flex filter-buttons" style="background-color: #fff">
              <button class="remove" @click="handleClose()">
                {{ closebuttonText }}
              </button>
              <v-spacer />
              <button class="apply" @click="filterData()">Apply Filters</button>
            </div>
          </div>
        </v-menu>
      </div>
    </div>
    <div class="loader_con" v-if="!isClicked && !loader">
      <p>Please Select a Date Range and Term</p>
    </div>
    <div class="loader_con" v-if="isClicked && loader">
      <v-progress-circular
        indeterminate
        color="#1F8F58"
        size="40"
      ></v-progress-circular>
    </div>
    <div
      class="loader_con"
      v-else-if="(apiData.length == 0 || data.length == 0 )&& isClicked"
    >
      <p>No data found on selected term</p>
    </div>
    <div class="mt-0 graph" v-else-if="apiData.length != 0">
      <!-- <div class="flex">
                    <small class="legend_text">{{ heading }}</small>
                </div> -->
      <div class="flex mb-2" style="overflow-x: scroll; overflow: hidden">
        <!-- <small style="transform: rotate(-90deg); width: 20px">COUNT</small> -->
        <div style="width: 500px; overflow-x: scroll">
          <line-chart :data="data" height="240px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import methods from "../../../../helpers/methods";
import Checkbox from "../../MyFarmers/components/checkbox.vue";
export default {
  name: "lineGraph",
  data() {
    return {
      searchTextData: null,
      data: [],
      showFilter: false,
      isApicalled: false,
      isClicked: false,
      loader: false,
      msg: { empty: "Please Select a Date Range " },
      closebuttonText: "Close",
      selected: [],
      items: [],
    };
  },
  props: {
    apiData: {
      type: Array,
    },
    heading: {
      type: String,
      default: "",
    },

    click: {
      type: Boolean,
      default: false,
    },
    filterText: {
      type: String,
      default: "Select",
    },
  },
  watch: {
    searchTextData: function (val) {
    //   console.log("qweertty", val);
      this.heading = val;
      //this.formatSearchData();
    },
    selected: function (val) {
      console.log("selected CHeckbox", val, val.length);
      if (this.selected.length > 5) {
        this.showToast("you can Select Max 5 options ", "info", 10000);
        this.selected.pop();
      }
    },
    apiData: function (val) {
      this.data = [];
      this.items = [];
      this.selected = [];
      console.log("qweertty apData", val);
      val.map((item) => {
        console.log("loop on crop", item.id);
        if (item.entries.length != 0) this.items.push(item.name);
      });
      val.map((item, index) => {
        if (index < 5) {
          console.log("loop on crop", item.id);
          const data = {};
          item.entries.map((entries) => {
            let date=new Date(entries.name)
            data[moment(date).format('MMMM/YYYY')] = entries.count;
          });

          if (item.entries.length != 0) {
            this.data.push({ name: item.name, data: data });
          }
        }
      });
    },
    showFilter: function (val) {
      if (this.closebuttonText == "Close") {
        this.selected = [];
      }
      console.log("filter", val);
    },
  },
  methods: {
    filterData() {
      if (this.selected.length == 0) {
        this.data = [];
        this.apiData.map((item, index) => {
          if (index < 5) {
            console.log("loop on crop", item.id);
            const data = {};
            item.entries.map((entries) => {
             let date=new Date(entries.name)
            data[moment(date).format('MMMM/YYYY')] = entries.count;
            });
            if (item.entries.length != 0) {
              this.data.push({ name: item.name, data: data });
            }
          }
        });
         this.loader = false;
         this.closebuttonText = "Close";
         this.showFilter = true;
      }else{
        this.data = [];
        this.showFilter = true;
        this.loader = true;
        this.apiData.map((item) => {
            if (this.selected.indexOf(item.name) != -1) {
            const data = {};
            item.entries.map((entries) => {
                let date=new Date(entries.name)
                data[moment(date).format('MMMM/YYYY')] = entries.count;
            });
            if (item.entries.length != 0) {
                this.data.push({ name: item.name, data: data });
            }

            console.log("loop on crop", item.id);
            }
        });
        this.loader = false;
        this.closebuttonText = "Remove Filters";
         this.showFilter = true;
        }
      
    },
    handleClose() {
      this.selected = [];

      if (this.closebuttonText == "Remove Filters") {
        this.data = [];
        this.apiData.map((item, index) => {
          if (index < 5) {
            console.log("loop on crop", item.id);
            const data = {};
            item.entries.map((entries) => {
              let date=new Date(entries.name)
              data[moment(date).format('MMMM/YYYY')] = entries.count;
            });
            if (item.entries.length != 0) {
              this.data.push({ name: item.name, data: data });
            }
          }
        });
        this.closebuttonText = "Close";
      }
      this.showFilter = true;
    },
  },
  components: { Checkbox },
};
</script>
<style scoped lang="scss">
.graph_box {
  background-color: #fbfbfb;
  height: 360px;
  border-radius: 8px;
  overflow-x: scroll;
}

.graph {
  padding: 1rem;
}

.legend_text {
  font-size: 12px;
  text-align: center;
  color: #918989;
}

.loader_class {
  /* transform: translate3d(50%,0%,0%); */
  height: 300px;
  /* transform: translateY(-1%) */
}

.loader_message {
  transform: translateY(-100px);
}

.remove {
  background-color: rgba(57, 186, 123, 0.11);
  width: 43%;
  color: #328736;
}

.apply {
  background-color: #36983b;
  width: 55%;
  color: #fff;
}

.filter-buttons {
  // height: 10%;
  margin-left: 8px;
  margin-right: 8px;

  width: 90%;
  column-gap: 4px;
  position: fixed;
  bottom: 0px;
  background-color: #ffffff;
  z-index: 1;
  padding: 10px 0px;

  button {
    padding: 10px 10px;
    border-radius: 5px;
    font-size: 0.8rem;
    font-weight: 500;
  }
}

.loader_con {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  //  background-color: red;

  p {
    color: #999999;
    font-size: 0.9rem;
    font-family: "Lucida Grande", "Lucida Sans Unicode", Verdana, Arial,
      Helvetica, sans-serif;
  }
}
.heading {
  padding-top: 18px !important;
  margin-left: 18px;
  font-weight: 500;
  font-size: 16px;
}
</style>
